// /forgot-password
import { API } from "../../apiSlice";

export const sendOtpNewEmailApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    sendOtpNewEmail: builder.mutation({
      query: (data) => {
        return {
          url: "users/send-change-email-otp",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useSendOtpNewEmailMutation } = sendOtpNewEmailApiSlice;
